import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Product } from '@app/shared/classes/product';
import { NewProductSlider } from '@app/shared/data/slider';
import { ProductService } from '@app/shared/services/product.service';

@Component({
  selector: 'app-event-item-box-vertical-slider',
  templateUrl: './event-item-box-vertical-slider.component.html',
  styleUrls: ['./event-item-box-vertical-slider.component.scss']
})
export class EventItemBoxVerticalSliderComponent implements OnInit {

  public title: string = 'Available Tickets';
  @Output() ticketSelected: EventEmitter<Product[]> = new EventEmitter<Product[]>();
  @Output() ticketTotals: EventEmitter<number> = new EventEmitter<number>();

  @Input() tickets : Product[] = [];
  selectedTickets: Product[] = [];
  maxedQty: boolean

  public NewProductSliderConfig: any = NewProductSlider;

  constructor(public productService: ProductService) { 
  }

  ngOnInit(): void {
    this.tickets = this.tickets.map(ticket => ({
      ...ticket,
      quantity: ticket.quantity ?? 0
    }));
  }

  get totalPrice(): number {
    return this.tickets.reduce((sum, ticket) => sum + (ticket.price * ticket.quantity), 0);
  }

  increaseQuantity(index: number) {
    this.tickets[index].quantity = (this.tickets[index].quantity || 0) + 1;
    this.updateSelectedTickets();
  }

  decreaseQuantity(index: number) {
    if (this.tickets[index].quantity > 0) {
      this.tickets[index].quantity--;
      this.updateSelectedTickets();
    }
  }
  
  updateQuantity(ticket: any, event: any) {
    ticket.quantity = event.target.value;
    this.updateSelectedTickets();
  }

  updateSelectedTickets() {
    // Filter only tickets with quantity > 0
    this.selectedTickets = this.tickets.filter(ticket => ticket.quantity > 0);

    // Emit updated ticket list and total price
    this.ticketSelected.emit(this.selectedTickets);
    this.ticketTotals.emit(this.totalPrice);
  }
  
}